import Events from 'events'
import Vue from 'vue'

const events = new Events()
export default events

Vue.prototype.$events = events
